<template>
    <div class="carBox">
        <el-card class="box-card">
            <div class="mainBody">
                <div class="searchBox">
                    <div class="searchGroup">
                        <label>项目名称：</label>
                        <el-input v-model="search_Obj.f_project_name" clearable @keyup.enter.native="doSearch"></el-input>
                    </div>
                    <el-button type="primary" plain @click.native="doSearch">搜索</el-button>
                    <Btns :menu_id="menu_id" :menus="main_btns" @on_btnclk="btnClick"></Btns>
                </div>
                <div class="dataBox">
                    <el-table :data="tableData" :default-sort="sortData" @sort-change="sortChange" @selection-change="selectChanges" v-loading="loading" border stripe>
                        <el-table-column prop="project_name" label="项目名称" sortable="custom"></el-table-column>
                        <el-table-column prop="access_token" label="令牌" sortable="custom"></el-table-column>
                        <el-table-column prop="refresh_token" label="刷新令牌" sortable="custom"></el-table-column>
                        <el-table-column prop="expire_time" label="过期时间" sortable="custom"></el-table-column>
                        <el-table-column prop="create_time" label="生成时间" sortable="custom"></el-table-column>
                        <el-table-column label="操作" width="240" align="center">
                            <template slot-scope="scope">
                                <LabBtns :menu_id="menu_id" :row="scope.row" :index="scope.$index" :menus="lab_btns" @on_btnclk="labelClick"></LabBtns>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="pageBox">
                    <el-pagination background layout="total, sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 50]" :current-page="current" :page-size="pagesize" :total="total" @current-change="pageChange" @size-change="handleSizeChange"></el-pagination>
                </div>
                <Edit
                    width="600px"
                    :id="model_id"
                    :title="edit_title"
                    :isshow="editshow"
                    @on-close="closeEditDialog"
                    @on-save-ok="saveOk">
                </Edit>
                <Info
                    width="600px"
                    :id="model_id"
                    title="查看口令"
                    :isshow="infoshow"
                    @on-close="closeInfoDialog">
                </Info>
                <Interface
                    width="600px"
                    :access_token_id="model_id"
                    title="设置TOKEN权限"
                    :isshow="interfaceshow"
                    @on-close="closeInterfaceDialog">
                </Interface>
                <InterfaceVisit
                    width="1000px"
                    title="接口访问统计"
                    :isshow="interfacevisitshow"
                    @on-close="closeInterfaceVisitDialog">
                </InterfaceVisit>
            </div>
        </el-card>
    </div>
</template>

<script>
import Btns from "@/components/common/btns"
import LabBtns from "@/components/common/labbtns"
import Edit from "./edit"
import Info from "./info"
import Interface from "./interface.vue"
import InterfaceVisit from "./interfacevisit.vue"
import listutil from "@/libs/listutil"

export default {
    name: 'accessTokenList',
    mixins: [listutil],
    components: {Edit, Info, Interface, InterfaceVisit, Btns, LabBtns},
    data() {
        return {
            m_name: '项目口令',
            menu_id: 1230,
            list_url: "/api/admin/accesstoken/list",
            search_Obj: {
                f_project_name: '',
            },
            del_Obj:{
                url:'/api/admin/accesstoken/del',
                data:{
                    ids:''
                }
            },
            enu_name: [],
            interfaceshow: false,
            interfacevisitshow: false,
        };
    },
    methods: {
        permission(index, row) {
            this.model_id = row.id
            this.interfaceshow = true
        },
        closeInterfaceDialog(){
            this.interfaceshow = false
        },
        statistic(){
            this.interfacevisitshow = true
        },
        closeInterfaceVisitDialog(){
            this.interfacevisitshow = false
        },
    }
};
</script>